<template>
  <div>
    <b-card>
      <div class="flex justify-between">
        <div class="top-txt">
          <h4><b>Corporated Booking</b></h4>
        </div>
        <!-- <b-button disabled size="lg" class="border-solid border-2">Download Sample File</b-button> -->
        <base-button
          outline
          type="primary"
          @click="showaddbooking"
          class="flex px-6 py-1 mx-1"
          >+ Add Booking</base-button
        >
      </div>
      <b-input-group class="my-6">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush"
        header-row-class-name="thead-light table-th-color"
        :data="tableData"
        border
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->

        <el-table-column label="Name" min-width="250px" prop="name">
          <template v-slot="{ row }">
            <b-media class="align-items-center">
              <a href="#" class="w-3/5 mr-3">
                <!-- <img alt="row.title" class="w-full rounded-lg" :src="row.img" /> -->
                {{ row.companyName }}
              </a>
            </b-media>
          </template>
        </el-table-column>

        <el-table-column label="Company Name" min-width="250px" prop="name">
          <template v-slot="{ row }">
            <b-media no-body class="align-items-center">
              <a href="#" class="w-3/5 mr-3">
                <!-- <img alt="row.title" class="w-full rounded-lg" :src="row.img" /> -->
                {{ row.companyName }}
              </a>
            </b-media>
          </template>
        </el-table-column>

        <el-table-column label="Email" min-width="190px" prop="orderno">
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.email }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Mobile No."
          prop="mobile"
          min-width="160px"
          v-slot="{ row }"
        >
          <p>
            {{ row.mobileno }}
          </p>
        </el-table-column>

        <el-table-column label="Start Date" prop="date" min-width="160px">
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{
                new Date(row.startDate).toLocaleDateString("en-IN", {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                })
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="End Date" prop="date" min-width="160px">
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{
                new Date(row.endDate).toLocaleDateString("en-IN", {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                })
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="No. of License"
          min-width="190px"
          prop="orderno"
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.licence }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column
          label="Status"
          min-width="150px"
          prop="statusaction"
          sortable
        > -->
        <!-- <template>
            <base-button
              :class="`bg-${row.actioncolor}`"
              class="border-none cust-btn-xs"
              size="sm"
              >{{ row.status ? "Active" : "InActive" }}</base-button
            >
          </template> -->
        <!-- <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.status }}</span>
          </template>
        </el-table-column> -->

        <el-table-column label="Edited By" prop="editedby" min-width="160px">
          <template v-slot="{ row }">
            <p
              class="font-semibold text-left name mb-0 text-sm"
              v-if="row.isEdited"
            >
              {{
                row.editedBy.at(-1)._user.firstname +
                  " " +
                  row.editedBy.at(-1)._user.lastname || " "
              }}
            </p>
          </template>
        </el-table-column>

        <el-table-column label="Action" min-width="190px">
          <template slot-scope="scope">
            <div class="flex items-center">
              <div class="flex items-center mr-4 cursor-pointer">
                <!-- <feather-icon
                @click="editModal = true"
                block
                icon="Edit3Icon"
                svgClasses="w-5"
              ></feather-icon> -->
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-6 text-blue-500 cursor-pointer"
                  class="mr-2"
                  @click="handleEdit(scope)"
                ></feather-icon>
              </div>
              <div class="flex items-center cursor-pointer">
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-6 text-red-600 cursor-pointer"
                  class="ml-2"
                  @click="handleDelete(scope)"
                ></feather-icon>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import "@/assets/scss/Index.scss";
import { mapState } from "vuex";
// import EditDetail from "./components/EditDetail.vue";
// import AddBannerSidebar from "./components/AddBannerSidebar.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    // EditDetail,
    // AddBannerSidebar
  },
  data() {
    return {
      // CompanyData,
      perPage: 10,
      totalRows: 0,
      tableData: [],
      search: "",
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
    };
  },
  watch: {
    async currentPage() {
      await this.getAll();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getAll();
        this.currentPage = 1;
      }, 500),
    },
  },
  methods: {
    showaddbooking() {
      this.$router.push({ name: "admin-addbooking" });
    },
    async getAll() {
      // this.$store.dispatch("corporate/get_all", payload);
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };

      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading();
        const getBooking = await this.$store.dispatch(
          "corporate/get_all",
          payload
        );
        // console.log(getBooking);
        loader.close();
        this.totalRows = this.get_AllBooking.totalCount;
        this.tableData = this.get_AllBooking.result;
      } catch (error) {
        console.log(error);
        loader.close();
      }

      // console.log(this.get_AllBooking);
    },
    addBanner() {
      // console.log(this.get_AllBooking);
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to use this email and mobile number again to register!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = {
        _id: row._id,
      };
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("corporate/delete", payload);
        loader.close();
        if (data.code === 200) {
          await this.getAll();
          await this.$swal.fire({
            text: "Booking successfully deleted!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
    },
    async handleEdit(scope) {
      let { row } = scope;

      this.$store.commit("corporate/SELECT_Booking", row);
      this.$router.push({ name: "editbooking" });
    },
  },

  computed: {
    ...mapState("corporate", { get_AllBooking: "get_AllBooking" }),

    // displayedPages() {
    //   return this.get_AllBooking.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
  },
  async mounted() {
    await this.getAll();
  },
  // totalPages() {
  //   return this.get_AllBooking.length;
  // },
};
</script>
<style>
.justify-spacebetween {
  justify-content: space-between;
}
.btn-add-booking {
  border: 1px solid purple;
  padding: 10px 20px 10px 17px;
  color: purple;
  font-weight: 600;
}
</style>
